import React from 'react';
import PropTypes from 'prop-types';

// AB#14852: renders a leak-rate fraction from the API (0.123 = 12.3%) as a percentage
// with exactly one decimal place. Null/missing data renders as an em-dash, zero as "0.0%".
// Unlike <Percentage />, the value arrives unscaled (the API never pre-scales DWH values).
const FractionPercentage = ({ value }) => {

    if (value === null || value === undefined || value === "") {
        return <span>&mdash;</span>;
    }

    return (
        <span>
            {`${(parseFloat(value) * 100).toFixed(1)}%`}
        </span>
    );
};

FractionPercentage.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ])
};

FractionPercentage.defaultProps = {};

export default FractionPercentage;
